(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => '$' + (cents / 100).toLocaleString('en-CA', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- carousels ---------- */
  $$('[data-car]').forEach((car) => {
    const track = $('.car-track', car);
    if (!track) return;
    const bar = $('.car-progress i', car);
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 14 : 300);
    $$('.car-arrow', car).forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: step() * Number(b.dataset.dir), behavior: 'smooth' })));
    const upd = () => {
      if (!bar) return;
      const max = track.scrollWidth - track.clientWidth;
      const vis = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      bar.style.width = Math.max(vis * 100, 12) + '%';
      bar.style.marginLeft = (max > 0 ? (track.scrollLeft / max) * (100 - Math.max(vis * 100, 12)) : 0) + '%';
      car.querySelector('.car-progress').style.display = max > 4 ? '' : 'none';
      $$('.car-arrow', car).forEach((a) => (a.style.display = max > 4 ? '' : 'none'));
    };
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  });

  /* ---------- header: search, mobile menu, touch mega ---------- */
  const sp = $('#searchPanel');
  $('#openSearch') && $('#openSearch').addEventListener('click', () => { sp.classList.toggle('open'); if (sp.classList.contains('open')) $('input', sp).focus(); });
  const mn = $('#mobileNav');
  $('#openMenu') && $('#openMenu').addEventListener('click', () => mn.classList.add('open'));
  $('#closeMenu') && $('#closeMenu').addEventListener('click', () => mn.classList.remove('open'));
  $$('.nav-item > button').forEach((b) => b.addEventListener('click', () => {
    const it = b.parentElement; const open = it.classList.contains('open');
    $$('.nav-item.open').forEach((x) => x.classList.remove('open'));
    if (!open) it.classList.add('open');
  }));
  document.addEventListener('click', (e) => { if (!e.target.closest('.nav-item')) $$('.nav-item.open').forEach((x) => x.classList.remove('open')); });

  /* ---------- install date / time / postal (shared by drawer + cart page) ---------- */
  const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const MON = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const iso = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const todayIso = iso(today);
  const maxDay = new Date(today); maxDay.setDate(today.getDate() + 30);
  const state = { date: '', slot: '', postal: '' };
  let attrsLoaded = false, saveT = null;
  const core = /^(M|L1[A-Z]|L3[P-T]|L4[A-Z]|L5|L6[A-M]|L7[L-T]|L9[LP]|L0B|K9[HJKLV]|K0M|K8[NPR]|N1[EGHKLPRST]|N2|N3[CEHLPRSTV])/;

  function fillDateSelect(sel) {
    let h = '<option value="">Select date</option>';
    for (let i = 0; i <= 30; i++) {
      const d = new Date(today); d.setDate(today.getDate() + i);
      h += '<option value="' + iso(d) + '">' + (i === 0 ? 'Today, ' : i === 1 ? 'Tomorrow, ' : '') + DOW[d.getDay()] + ' ' + MON[d.getMonth()].slice(0, 3) + ' ' + d.getDate() + '</option>';
    }
    sel.innerHTML = h;
  }
  function drawCal(cal) {
    const off = cal._m || 0;
    const base = new Date(today.getFullYear(), today.getMonth() + off, 1);
    const y = base.getFullYear(), m = base.getMonth();
    let h = '<div class="mc-cal-head"><button type="button" data-cm="-1" aria-label="Previous month"' + (off <= 0 ? ' disabled' : '') + '>‹</button><b>' + MON[m] + ' ' + y + '</b><button type="button" data-cm="1" aria-label="Next month"' + (new Date(y, m + 1, 1) > maxDay ? ' disabled' : '') + '>›</button></div><div class="mc-cal-grid">';
    ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].forEach((dn) => { h += '<span class="dow">' + dn + '</span>'; });
    const lead = (base.getDay() + 6) % 7;
    for (let i = 0; i < lead; i++) h += '<span></span>';
    const days = new Date(y, m + 1, 0).getDate();
    for (let d = 1; d <= days; d++) {
      const dt = new Date(y, m, d), v = iso(dt), ok = dt >= today && dt <= maxDay;
      h += '<button type="button" class="' + (ok ? 'ok' : '') + (v === todayIso ? ' today' : '') + (v === state.date ? ' sel' : '') + '" ' + (ok ? 'data-d="' + v + '"' : 'disabled') + ' aria-label="' + DOW[dt.getDay()] + ' ' + MON[m] + ' ' + d + '"' + (v === state.date ? ' aria-pressed="true"' : '') + '>' + d + '</button>';
    }
    cal.innerHTML = h + '</div>';
  }
  function pcMsg(box) {
    const el = $('[data-pcmsg]', box); if (!el) return;
    const v = state.postal.toUpperCase().replace(/\s+/g, '');
    if (v.length < 3) { el.textContent = ''; el.className = 'mc-pcmsg'; return; }
    if (core.test(v)) { el.textContent = 'Great, we install in your area.'; el.className = 'mc-pcmsg ok'; }
    else { el.textContent = "You may be outside our usual area. You can still order and we'll call to confirm."; el.className = 'mc-pcmsg warn'; }
  }
  function syncAll() {
    $$('[data-install]').forEach((box) => {
      const ds = $('select[name=date]', box); if (ds) ds.value = state.date;
      const ss = $('select[name=slot]', box); if (ss) ss.value = state.slot;
      const pc = $('input[name=postal]', box); if (pc && document.activeElement !== pc) pc.value = state.postal;
      const sd = $('[data-sameday]', box); if (sd) sd.hidden = state.date !== todayIso;
      const cal = $('[data-cal]', box); if (cal) drawCal(cal);
      pcMsg(box);
    });
  }
  const attrs = () => ({ 'Preferred install date': state.date, 'Preferred time': state.slot, 'Install postal code': state.postal.toUpperCase() });
  const saveAttrs = () => fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs() }) }).catch(() => {});
  const queueSave = () => { clearTimeout(saveT); saveT = setTimeout(saveAttrs, 500); };
  $$('[data-datesel]').forEach(fillDateSelect);
  $$('[data-install]').forEach((box) => {
    box.addEventListener('change', (e) => {
      if (e.target.name === 'date') state.date = e.target.value;
      if (e.target.name === 'slot') state.slot = e.target.value;
      if (e.target.name === 'date' || e.target.name === 'slot') { const er = $('[data-err]', box); if (er) er.hidden = true; syncAll(); queueSave(); }
    });
    box.addEventListener('input', (e) => { if (e.target.name === 'postal') { state.postal = e.target.value; pcMsg(box); queueSave(); } });
    box.addEventListener('click', (e) => {
      const d = e.target.closest('[data-d]');
      if (d) { state.date = d.dataset.d; const er = $('[data-err]', box); if (er) er.hidden = true; syncAll(); queueSave(); return; }
      const cm = e.target.closest('[data-cm]');
      if (cm) { const cal = cm.closest('[data-cal]'); cal._m = (cal._m || 0) + Number(cm.dataset.cm); drawCal(cal); }
    });
  });
  syncAll();

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-checkout]'); if (!b) return;
    const box = b.closest('[data-install]'); const er = box && $('[data-err]', box);
    const fail = (msg) => { if (er) { er.textContent = msg; er.hidden = false; } };
    if (!state.date) return fail('Please choose your preferred installation date.');
    if (!state.slot) return fail('Please choose a time slot.');
    b.disabled = true; b.textContent = 'One moment…';
    await saveAttrs();
    window.location.href = '/checkout';
  });

  /* ---------- cart rendering (drawer + cart page) ---------- */
  let meta = {}; try { meta = JSON.parse($('#mxCartMeta').textContent); } catch (e) {}
  const IC = {
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6l8-3z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
    doc: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8l-5-5z"/><path d="M14 3v5h5M8 13h8M8 17h5"/></svg>'
  };
  const img = (u) => (u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '');
  function lineHTML(it, page) {
    const title = it.product_title.replace(/ [–-] Installed$/, '');
    const w = (meta[it.product_id] || {}).w;
    const orig = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
    return '<div class="mc-line" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
      '<a class="mc-img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="">' : '') + '</a>' +
      '<div><a class="mc-title" href="' + esc(it.url) + '">' + esc(title) + '</a>' +
      (it.variant_title ? '<span class="mc-var">' + esc(it.variant_title) + '</span>' : '') +
      '<div class="mc-row"><span class="mc-price">' + money(it.final_line_price) + orig + '</span>' +
      '<div class="mc-qty"><button type="button" data-q="-1" aria-label="Decrease quantity">−</button><span aria-label="Quantity">' + it.quantity + '</span><button type="button" data-q="1" aria-label="Increase quantity">+</button></div>' +
      '<button type="button" class="mc-rm" data-rm aria-label="Remove ' + esc(title) + '">' + IC.trash + (page ? '<span>Remove</span>' : '') + '</button></div></div>' +
      '<ul class="mc-badges"><li>' + IC.shield + 'Standard installation included, by certified installers</li>' + (w ? '<li>' + IC.doc + esc(w.charAt(0).toUpperCase() + w.slice(1)) + '</li>' : '') + '</ul></div>';
  }
  const emptyDrawer = () => { const t = $('#mcEmptyTpl'); return t ? t.innerHTML : '<div class="mc-empty"><p>Your cart is empty.</p><a href="/collections/all">Shop systems</a></div>'; };
  async function renderCart(cart) {
    if (!cart) cart = await fetch('/cart.js').then((r) => r.json());
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
    $$('[data-cart-count-text]').forEach((el) => (el.textContent = cart.item_count));
    ['#cartTotal', '#cartPageTotal'].forEach((s) => { const t = $(s); if (t) t.textContent = money(cart.total_price); });
    if (!attrsLoaded) {
      attrsLoaded = true;
      const a = cart.attributes || {};
      if (a['Preferred install date'] && a['Preferred install date'] >= todayIso) state.date = a['Preferred install date'];
      if (a['Preferred time']) state.slot = a['Preferred time'];
      if (a['Install postal code']) state.postal = a['Install postal code'];
      syncAll();
    }
    const empty = !cart.items.length;
    drawer && drawer.classList.toggle('is-empty', empty);
    const pageSec = $('.mc-page'); pageSec && pageSec.classList.toggle('mc-cart-empty', empty);
    [['#cartItems', false], ['#cartPageItems', true]].forEach(([sel, page]) => {
      const box = $(sel); if (!box) return;
      box.innerHTML = empty ? (page ? '<div class="mc-card mc-empty"><p>Your cart is empty.</p><a href="/collections/all">Shop systems</a></div>' : emptyDrawer()) : cart.items.map((it) => lineHTML(it, page)).join('');
    });
  }
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-q]'), rm = e.target.closest('[data-rm]');
    if (!q && !rm) return;
    const line = e.target.closest('.mc-line'); if (!line) return;
    const qty = rm ? 0 : Math.max(0, Number(line.dataset.qty) + Number(q.dataset.q));
    line.classList.add('busy');
    try {
      const cart = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.dataset.key, quantity: qty }) }).then((r) => r.json());
      renderCart(cart);
    } catch (err) { line.classList.remove('busy'); }
  });

  const drawer = $('#drawer'), overlay = $('#overlay');
  const openCart = () => { if (!drawer) return; renderCart(); drawer.classList.add('open'); overlay.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); };
  const closeCart = () => { if (!drawer) return; drawer.classList.remove('open'); overlay.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); };
  $('#openCart') && $('#openCart').addEventListener('click', (e) => { if ($('#cartPageItems')) return; e.preventDefault(); openCart(); });
  $('#closeCart') && $('#closeCart').addEventListener('click', closeCart);
  overlay && overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeCart(); mn && mn.classList.remove('open'); } });
  if ($('#cartPageItems')) renderCart();

  /* empty-cart drawer: continue shopping + quick add popular products */
  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-close-cart]')) { e.preventDefault(); closeCart(); return; }
    const a = e.target.closest('[data-pop-add]'); if (!a) return;
    e.preventDefault();
    a.disabled = true; a.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(a.dataset.popAdd), quantity: 1 }] }) });
      if (!res.ok) throw new Error('add failed');
      renderCart();
    } catch (err) { window.location.href = a.dataset.url || '/collections/all'; }
  });

  $$('form[data-ajax-add]').forEach((f) => f.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = $('button[type=submit]', f); const label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) });
      if (!res.ok) throw new Error('add failed');
      openCart();
    } catch (err) { f.submit(); }
    finally { btn.disabled = false; btn.textContent = label; }
  }));

  /* ---------- product page ---------- */
  const pj = $('#productJson');
  if (pj) {
    const product = JSON.parse(pj.textContent);
    const input = $('[data-variant-input]');
    const setVariant = (id) => {
      const v = product.variants.find((x) => String(x.id) === String(id)); if (!v) return;
      input.value = v.id;
      $$('[data-variant-pills] button').forEach((b) => b.classList.toggle('on', b.dataset.variant === String(v.id)));
      $$('[data-price]').forEach((el) => (el.textContent = money(v.price)));
      $$('[data-sku]').forEach((el) => (el.textContent = v.sku || ''));
      $$('[data-spec-for]').forEach((el) => (el.hidden = el.dataset.specFor !== String(v.id)));
      const atc = $('.pdp-atc button'); if (atc) atc.disabled = !v.available;
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    };
    $$('[data-variant-pills] button').forEach((b) => b.addEventListener('click', () => setVariant(b.dataset.variant)));
    $$('[data-paytype] input').forEach((r) => r.addEventListener('change', () => $$('[data-paytype] label').forEach((l) => l.classList.toggle('on', $('input', l).checked))));
    $$('[data-thumb]').forEach((t) => t.addEventListener('click', () => {
      $('#pdpMain').src = t.dataset.thumb; $$('[data-thumb]').forEach((x) => x.classList.toggle('on', x === t));
    }));
  }

  /* ---------- hub brand tabs (legacy) ---------- */
  const tabs = $('[data-brand-tabs]');
  if (tabs) {
    $$('button', tabs).forEach((b) => b.addEventListener('click', () => {
      $$('button', tabs).forEach((x) => x.classList.toggle('on', x === b));
      $$('[data-brand-grid] > [data-vendor]').forEach((c) => (c.hidden = !(b.dataset.vendor === 'all' || c.dataset.vendor === b.dataset.vendor)));
    }));
  }

  /* ---------- lead form prefill ---------- */
  const qp = new URLSearchParams(location.search).get('product');
  if (qp) $$('[data-product-field]').forEach((f) => { f.value = qp; const ta = f.closest('form').querySelector('textarea'); if (ta && !ta.value) ta.value = 'I have a question about: ' + qp; });
})();